import { siteInfo, heroStats } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 25% 50%, oklch(var(--primary-500)) 0%, transparent 60%), radial-gradient(circle at 75% 30%, oklch(var(--accent-500)) 0%, transparent 50%)',
        }}
      />

      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full flex flex-col items-start gap-6">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold tracking-wide">
              <i className="ri-fire-line"></i>
              {siteInfo.tagline}
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight tracking-tight">
              {siteInfo.name}
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-600 mt-2">
                {siteInfo.slogan}
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-[560px]">
              {siteInfo.name}致力于为广大影视爱好者提供一站式免费观影体验。我们聚合西瓜视频免费、91在线视频、小蓝视频、久久视频等全网热门影视平台资源，涵盖电影、电视剧、综艺、动漫等全品类内容。无需付费、无需注册，即点即播不缓冲，每日更新最新剧集，让您畅享高清免费影视盛宴。
            </p>

            <div className="flex flex-wrap items-center gap-5 md:gap-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="text-xl md:text-2xl font-heading font-bold text-primary-600">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-600">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
              <a
                href="#carousel"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观看
              </a>
              <a
                href="#about"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 border border-secondary-300 text-foreground-700 text-sm md:text-base font-medium rounded-md hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20popcorn%20on%20a%20warm%20dark%20wooden%20table%2C%20golden%20spotlight%20beam%20from%20above%20creating%20dramatic%20atmosphere%2C%20movie%20theater%20aesthetic%20with%20rich%20warm%20amber%20and%20deep%20shadow%20tones%2C%20elegant%20composition%2C%20professional%20product%20photography%20with%20soft%20depth%20of%20field%2C%20luxurious%20cinema%20vibe%2C%20no%20text%20or%20watermarks&width=1040&height=780&seq=hero-main-visual-2026&orientation=landscape"
                alt="番茄视频 - 免费高清影视聚合平台主视觉"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.classList.add('hidden');
                  }
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}